import React from 'react';

const Skeleton = () => {
  return (
    <div className="bg-gray min-h-screen px-4 animate-pulse">
      {/* Header Section */}
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center mb-6 pt-4 sm:pt-6">
          <div className="w-8 h-8 mr-2 bg-gray-200 rounded" />
          <div className="h-8 w-32 bg-gray-200 rounded" />
        </div>

        {/* Step Indicators */}
        <div className="flex justify-between mb-6 sm:mb-8">
          {[1, 2, 3].map((step) => (
            <div key={step} className="flex flex-col items-center w-24">
              <div className="w-10 h-10 rounded-full bg-gray-200 mb-2" />
              <div className="w-20 h-4 bg-gray-200 rounded" />
            </div>
          ))}
        </div>

        {/* Content Area */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          {/* Title Bar */}
          <div className="mb-6">
            <div className="h-6 w-48 bg-gray-200 rounded mb-2" />
            <div className="h-4 w-64 bg-gray-200 rounded" />
          </div>

          {/* Skeleton Cards */}
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {[1, 2, 3].map((item) => (
              <div key={item} className="border rounded-lg p-4">
                <div className="w-full h-40 bg-gray-200 rounded mb-4" />
                <div className="h-5 w-3/4 bg-gray-200 rounded mb-3" />
                <div className="h-4 w-1/2 bg-gray-200 rounded mb-3" />
                <div className="h-4 w-2/3 bg-gray-200 rounded" />
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Action Area */}
        <div className="mt-6 flex justify-end space-x-4">
          <div className="w-24 h-10 bg-gray-200 rounded" />
          <div className="w-24 h-10 bg-gray-200 rounded" />
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
